export const LEVEL_INDENT = 42
export const CHAPTER_WITH_CHILDREN_OFFSET = 12
export const LINE_CHAPTER_OFFSET = 23
export const MAX_NESTED_LEVEL = 6
export const MAX_LENGTH_SECTION_TITLE = 248
export const MIN_LENGTH_SECTION_TITLE = 20
